import React, {useEffect, useState} from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';
import {WELCOME_TRANSLATIONS} from './welcomeTranslations';

const {FiArrowUpRight, FiPlay} = FiIcons;

function WelcomeStage({
  remaining,
  duration,
  name,
  flyer,
  language,
  revealed,
  onOpenDeck,
}) {
  const [wordIndex, setWordIndex] = useState(0);
  const progress = duration ? Math.min(100, (remaining / duration) * 100) : 0;
  const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
  const seconds = String(remaining % 60).padStart(2, '0');
  const welcomeWord = WELCOME_TRANSLATIONS[wordIndex]?.text || 'Welcome';

  useEffect(() => {
    const timer = window.setInterval(() => {
      setWordIndex(value => (value + 1) % WELCOME_TRANSLATIONS.length);
    }, 2300);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <section className={`welcome-stage ${revealed ? 'revealed' : ''}`}>
      <div className="stage-ring ring-one" />
      <div className="stage-ring ring-two" />
      <div className="stage-noise" />

      <AnimatePresence mode="wait">
        {revealed ? (
          <motion.div
            className="reveal-content"
            key="reveal"
            initial={{opacity: 0, scale: 1.06}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 1.2}}
          >
            <span className="stage-kicker">PROSPERITY • LAUNCH</span>
            <h1>{language === 'es' ? 'Bienvenido' : 'Welcome'}</h1>
            <h2>{name}</h2>
            <p>{language === 'es' ? 'Tu próximo capítulo comienza ahora.' : 'Your next chapter begins now.'}</p>
            <button className="deck-button" onClick={onOpenDeck}>
              <SafeIcon icon={FiPlay} />
              {language === 'es' ? 'Iniciar presentación' : 'Begin presentation'}
              <SafeIcon icon={FiArrowUpRight} />
            </button>
          </motion.div>
        ) : (
          <motion.div
            className="countdown-layout"
            key="countdown"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
          >
            <div className="countdown-copy">
              <span className="stage-kicker">PROSPERITY • VIRTUAL LAUNCH</span>
              <AnimatePresence mode="wait">
                <motion.h1
                  key={welcomeWord}
                  initial={{opacity: 0, y: 22}}
                  animate={{opacity: 1, y: 0}}
                  exit={{opacity: 0, y: -18}}
                  transition={{duration: 0.5}}
                >
                  {welcomeWord}
                </motion.h1>
              </AnimatePresence>
              <p>
                {language === 'es'
                  ? 'El evento comenzará en unos momentos.'
                  : 'The event will begin in just a moment.'}
              </p>

              <div className="countdown-card">
                <div className="countdown-label">
                  <span>{language === 'es' ? 'COMENZAMOS EN' : 'WE BEGIN IN'}</span>
                  <span>LIVE READY</span>
                </div>
                <div className={`countdown-time ${remaining <= 60 ? 'urgent' : ''}`}>
                  <span>{minutes}</span><i>:</i><span>{seconds}</span>
                </div>
                <div className="progress-bar">
                  <motion.i animate={{width: `${progress}%`}} transition={{duration: 0.3}} />
                </div>
              </div>
            </div>

            <div className="flyer-display">
              {flyer ? (
                <>
                  <img className="flyer-bg" src={flyer} alt="" />
                  <img className="flyer-fg" src={flyer} alt="Event flyer" />
                </>
              ) : (
                <div className="default-flyer">
                  <span>Your</span>
                  <b>Prosperity</b>
                  <span>Story starts here</span>
                  <i />
                  <small>Virtual business launch</small>
                </div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}

export default WelcomeStage;
